import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog,
    Paper, TextField, Box, Grid, TableCell, TableContainer, Typography,
    Table, TableHead, Button, IconButton, FormControl,
    InputLabel, TableRow, TableBody, Select, MenuItem, Input, Radio, RadioGroup, Card, Snackbar, Tooltip, Autocomplete, InputAdornment, OutlinedInput, FormHelperText,
} from '@mui/material';

import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'

import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { addCompany, addUserManagement, editDeleteCompany, editDeleteUserManagement, getCompanyList, getStateList } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import { makeStyles } from '@mui/styles';
import styles from '.././../../styles.module.css';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import SaveIcon from '@mui/icons-material/Save';    
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px',
    },
});


function UserManagementAdd(props) {
    const classes = useStyles();
    // const editData = props.details;
    const urlLocation = useLocation();
    const editData = urlLocation.state;
    const { handleSubmit } = useForm();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const editid = editData && editData.id;
    const [successMessage, setSuccessMessage] = useState(null);
    const [companyId, setCompanyName] = useState(editData ? editData.companyId : null);
    let navigate = useNavigate();
    const [data, setData] = useState({
        id: editid,
        userName: editData ? editData.userName : '',
        showPassword: false,
        password: editData ? editData.password : '',
        nameOfPerson: editData ? editData.nameOfPerson : '',
        designation: editData ? editData.designation : '',
        mobileNumber: editData ? editData.mobileNumber : '',
        email: editData ? editData.email : '',
        userRole: editData ? editData.userRole : 'Admin',
    });

    const companyList = useSelector(state => state.company.company)
    const handleClickShowPassword = () => {
        setData({
            ...data,
            showPassword: !data.showPassword,
        });
    };

    const handleSelectCompany = (event, newValue) => {
        setCompanyName(newValue)
    }

    const handleChange = ({ target }, event) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const companyNameGetData = () => {
        dispatch(getCompanyList({ companyId: userInfo.userRole == 'superAdmin' ? null : userInfo.companyId }))
    }

    useEffect(() => {
        companyNameGetData()
        if (editData) {
            setCompanyName({
                companyName: editData.companyName,
                companyId: editData.companyId,
                id: editData.companyId,
            })
        }
    }, []);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.userManagement.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'User already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        let userData = {
            ...data,
            companyId: userInfo.userRole == 'superAdmin' ? companyId.id : userInfo.companyId,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteUserManagement(userData))
        } else {
            dispatch(addUserManagement(userData))
        }

        // props.onAPISubmt();
        // props.handleCloseDialog();

    }

    return (
        <>
            <div>
            <Breadcrumb
                            routeSegments={[
                                { name: 'Settings', path: '/settings' },
                                { name: 'Users List', path: '/user-management' },
                                { name: 'Create User' },
                            ]}
                        />
                <Paper className={`${styles.list_container}`}>
                   
                    {/* <Box sx={{ display: 'flex', paddingLeft: '50px', }}>
                        <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create User</Typography>
                            </Grid>
                        </Grid>
                    </Box> */}
                     <Box sx={{ m: 4}} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box style={{ paddingLeft: '50px' }}>
                            <Grid container spacing={2} style={{ minHeight: '350px', }}>
                                <Grid item xs={4} >
                                    <Typography className={`${styles.erp_lable}`}> Create User to acess the Software application. <br />select the type of user from user role</Typography>
                                </Grid>
                                <Grid item xs={2} > </Grid>
                                <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    <Card className={`${styles.m_card}`}>
                                        <Grid container spacing={1} sx={{ mt: 1 }}>
                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Company Name</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                {userInfo.userRole == 'superAdmin' ?
                                                    <Autocomplete
                                                        fullWidth
                                                        classes={{
                                                            option: classes.option,
                                                        }}
                                                        noOptionsText={
                                                            <span className={classes.noOptionsLabel}>No options</span>
                                                        }
                                                        options={companyList}
                                                        value={companyId}
                                                        onChange={handleSelectCompany}
                                                        getOptionLabel={(option) => option.companyName}
                                                        getOptionSelected={(option, value) => option.id === value.companyId}
                                                        renderInput={(params) => <ERPinput required
                                                            placeholder="Please Select Company Name"
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: 25,
                                                                    fontSize: 12,
                                                                }
                                                            }} {...params} />}
                                                    />
                                                    :
                                                    <Typography className={`${styles.erp_lable}`} style={{ fontWeight: 600 }}>{userInfo.company}</Typography>
                                                }
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Role</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <FormControl fullWidth>
                                                    <ERPinput
                                                        required
                                                        select
                                                        name="userRole"
                                                        value={(data.userRole)}
                                                        size="small"
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem value="User" className={`${styles.erp_lable}`}>User</MenuItem>
                                                        <MenuItem value="Admin" className={`${styles.erp_lable}`}>Admin</MenuItem>
                                                    </ERPinput>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Name of Person</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    name="nameOfPerson"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={data.nameOfPerson}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Mobile Number</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    name="mobileNumber"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={data.mobileNumber}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Designation</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    name="designation"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={data.designation}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Email</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="email"
                                                    type="email"
                                                    onChange={handleChange}
                                                    value={(data.email)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>User Name</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <ERPinput
                                                    required
                                                    size='small'
                                                    fullWidth
                                                    name="userName"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={data.userName}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            {!editData &&
                                                <>
                                                    <Grid item xs={3}>
                                                        <Typography className={`${styles.erp_lable}`}>Password</Typography>
                                                    </Grid>
                                                    <Grid item xs={9}>
                                                        <OutlinedInput
                                                            style={{
                                                                height: '25px',
                                                                fontSize: '12px',
                                                                "& .MuiInputBase-root": {
                                                                }
                                                            }}
                                                            type={data.showPassword ? 'text' : 'password'}
                                                            name="password"
                                                            value={data.password}
                                                            onChange={handleChange}
                                                            fullWidth
                                                            required
                                                            endAdornment={
                                                                <InputAdornment position="end" >
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                        edge="end"
                                                                    >
                                                                        {data.showPassword ? <VisibilityOff style={{ fontSize: '18px' }} /> : <Visibility style={{ fontSize: '18px' }} />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={12}>
                                            <Box sx={{ marginTop: '12px', float: 'right' }}>
                                            <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                            <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                            </Button>
                                            <Cancel />
                                        </Box>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>

                        </Box>

                    </form>
                </Paper>
            </div>
            {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
        </>
    )
}

export default UserManagementAdd;